<template>
  <div>
    <h3>Was sind Cookies?</h3>
    <p>
      Cookies und ähnliche Technologien sind sehr kleine Textdateien oder Codeteile, die oft einen eindeutigen Identifikationscode enthalten. Wenn Sie eine Website besuchen oder eine mobile Anwendung verwenden, bittet ein Webserver Ihren Computer oder Ihr mobiles Gerät um die Erlaubnis, diese Datei auf Ihrem Computer oder mobilen Gerät zu speichern und Zugang zu Informationen zu erhalten. Informationen, die durch Cookies und ähnliche Technologien gesammelt werden, können das Datum und die Uhrzeit des Besuchs sowie die Art und Weise, wie Sie eine bestimmte Website oder mobile Anwendung nutzen, beinhalten.
    </p>

    <h3>Warum verwenden wir Cookies?</h3>
    <p>
      Cookies sorgen dafür, dass Sie während Ihres Besuchs auf Teach Economy eingeloggt bleiben und kein Missbrauch mit unseren Anmelde- und Kontakt-Formularen erfolgen kann. Weitere Cookies stellen auch sicher, dass wir sehen können, wie unsere Website genutzt wird und wie wir sie verbessern können. Dazu nutzen wir das bei uns gehostete Analyse-Tool Matomo mit der Erweiterung PrivacyManager, die die IP-Adressen anonymisiert. Im Unterschied zu Google Analytics sorgt diese Lösung dafür, dass Ihr Surfverhalten privat bleibt und – anonymisiert – ausschließlich dem Team von Teach Economy zur inhaltlichen und technischen Webseitenoptimierung dient. Darüber hinaus können Sie entscheiden, ob Sie Cookies von Drittanbietern (YouTube) zulassen wollen.
    </p>

    <h3>Welche Art von Cookies verwenden wir?</h3>

    <h4>Notwendige Cookies</h4>
    <p>
      Diese Cookies sind notwendig, damit die Website ordnungsgemäß funktioniert. Sinn und Zweck dieser Cookies:
    </p>
    <ul>
      <li>Schutz der Formulare vor Hacker-Attacken.</li>
      <li>Speicherung der Anmeldung eines registrierten Nutzers, damit geschützte Seiten aufgerufen werden können.</li>
      <li>Sammeln von statistischen Informationen über die Nutzung unserer Website mit Hilfe von Analyse-Cookies für Matomo.</li>
    </ul>

    <h4>Funktionale Cookies</h4>
    <p>
      Diese Cookies ermöglichen eine erweiterte Funktionalität für unsere Website-Besucher. Da wir YouTube bereits „cookieless“ einbinden, werden erst beim Start eines Videos Webdateien von YouTube auf Ihrem Rechner platziert. Sollten Sie diese Option nicht ausgewählt haben, können Sie bei einem von uns eingebundenen YouTube-Video immer noch den Abruf starten, indem Sie auf das Overlay über dem Film klicken. Die meisten unserer Videos werden jedoch bei Vimeo gehostet, dort werden keine Cookies gesetzt.
    </p>
  </div>
</template>

<script>
export default {
  name: 'VSettingsPolicy'
}
</script>
